import { GET_ERRORS, CLEAR_ERRORS, GET_ERRORS_REGISTRATION } from '../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ERRORS:
      return action.payload;
    case CLEAR_ERRORS:
      return {};
    case GET_ERRORS_REGISTRATION:
      return action.payload;
    default:
      return state;
  }
}
